var __TEMP__ = require('./_baseCreate.js');var baseCreate = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseLodash.js');var baseLodash = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = LodashWrapper;
